import { render, staticRenderFns } from "./VerifyCodeRecoveryPassword.vue?vue&type=template&id=3ed38ab9&scoped=true"
import script from "./VerifyCodeRecoveryPassword.vue?vue&type=script&lang=js"
export * from "./VerifyCodeRecoveryPassword.vue?vue&type=script&lang=js"
import style0 from "./VerifyCodeRecoveryPassword.vue?vue&type=style&index=0&id=3ed38ab9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed38ab9",
  null
  
)

export default component.exports